module.exports = __webpack_public_path__ + "static/media/truck-csm.e2a78070.png";